<template>
    <div>
        <b-modal id="modal-document" centered hide-footer no-close-on-backdrop no-close-on-esc size="lg"
            :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
            :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('recruitingDocument.title') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
                <b-dropdown id="dropdown-preview" class="load-dropdown mt-0" v-if="documentItem">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button :class="allowUpdateRecord ? 'mb-2' : ''" @click="downloadDoc(documentItem)">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recruitingDocument.download') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button class='mb-2' v-if="fileName && allowUpdateRecord" @click="removeFile()">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recruitingDocument.replaceDoc') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="showPopup(mediaID)" v-if="allowUpdateRecord">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recruitingDocument.delete') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown id="dropdown-preview" class="load-dropdown mt-0" v-if="!documentItem && fileName">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button @click="removeFile()">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recruitingDocument.replaceDoc') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
            </template>
            <div class="d-block text-center">
                <b-row class="mh-470px">
                    <b-col lg="4" md="8" sm="12">
                        <div class="text-left mb-3">
                            <label for="modal-datepicker" class="state">{{ $t('recruitingDocument.dateLabel') }}</label>
                            <date-picker v-model="documentData.date" :formatter="momentFormat" :range-separator="' - '"
                                @clear="documentData.date = ''" :placeholder="$t('recruitingDocument.selectDate')" class="date-picker-custom"
                                :teleport="'body'" :disabled="!allowUpdateRecord"></date-picker>
                            <p v-if="errors && errors.date" class="field-error">
                                {{ errors.date[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <b-form-group :label="$t('recruitingDocument.documentTypeLabel')" class="text-left mb-3">
                                <b-form-select class="f-12" :options="documentTypeOptions" v-model="documentData.document_type">
                                </b-form-select>
                                <p v-if="errors && errors.document_type" class="field-error mb-lg-3">
                                    {{ errors.document_type[0] }}
                                </p>
                            </b-form-group>
                        </div>
                    </b-col>
                    <b-col lg="8" sm="12">
                        <div class="upload-btn-wrapper" v-if="!fileName">
                            <b-img :src="require('@/assets/drop.svg')"></b-img>
                            <button v-if="!fileName" class="foo">
                                {{ $t('recruitingDocument.dropDocument') }}
                            </button>
                            <button v-else class="foo">{{ fileName }}</button>

                            <input ref="docFile" type="file" name="docFile" v-on:change="handleFileUpload"
                                accept=".pdf, .png, .jpg, .jpeg" />
                            <p v-if="errors && errors.document" class="field-error">
                                {{ errors.document[0] }}
                            </p>
                        </div>
                        <div v-else>
                            <div class="review-media-section" :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                                <iframe class="w-100 h-100 border-0" v-if="mediaType === 'pdf'" :src="media"></iframe>
                                <div v-else>
                                    <div id="panzoom-element" ref="panzoomElement">
                                        <img :src="media" class="w-100 h-100 img-section" />
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center zoom-section">
                                        <b-icon @click="zoom(1)" icon="zoom-in"
                                            style="fill:white; cursor: pointer;"></b-icon>
                                        <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out"
                                            style="fill:white;cursor: pointer;"></b-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="text-right modal-footer border-0 p-0 mt-4">
                <b-button class="mt-3 btn cancel m-0" :class="hasDocChanged && allowUpdateRecord ? 'mr-3' : ''" block
                    @click="resetPopup()">{{ documentItem ? $t('recruitingDocument.close') : $t('recruitingDocument.cancel') }}</b-button>
                <b-button class="mt-3 btn save mx-0 m-0" variant="primary" v-if="hasDocChanged && allowUpdateRecord"
                    @click="sendDocumentData">{{ $t('recruitingDocument.save') }}</b-button>
            </div>
        </b-modal>
        <DeleteModal v-if="showDeleteModal" @confirm="deleteItem($event)" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { checkValueExists, pickerDate } from '@/services/helper';
import DeleteModal from "@/components/DeleteModal.vue";
import Panzoom from '@panzoom/panzoom'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import * as moment from "moment-timezone";
export default {
    name: "Document",
    components: { DeleteModal, DatePicker },
    props: ['id', "documentItem", 'addDoc', 'updateDoc', 'allowVideo', 'driver', 'recordNo', 'mediaData', 'mediaDataID', 'mediaDataType', 'deleteDocItem', 'allowUpdateRecord'],
    data() {
        return {
            checkValueExists,
            fileName: null,
            media: null,
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            mediaType: null,
            panzoom: null,
            showDeleteModal: false,
            defaultDocsData: {},
            mediaID: null,
            documentData: {
                date: new Date(),
                document: null,
                document_type: ""
            },
            errors: {
                date: null,
                document: null,
            }
        }
    },
    computed: {
        ...mapGetters(['userCompany', 'docTypeItems']),
        documentTypeOptions() {
            return [
                { text: '-', value: '' },
                { text: this.$t('recruitingDocument.typeApplication'), value: 'Application' },
                { text: this.$t('recruitingDocument.typeFairCredit'), value: 'Fair Credit Reporting Act Disclosure Statement' },
                { text: this.$t('recruitingDocument.typeCertification'), value: 'Certification of Compliance With Driver License Requirements' },
                { text: this.$t('recruitingDocument.typeSafetyPerformance'), value: 'Safety Performance History Investigation' },
                { text: this.$t('recruitingDocument.typePspDriverDisclosure'), value: 'PSP Driver Disclosure & Authorization' },
                { text: this.$t('recruitingDocument.typeClearinghouseConsent'), value: 'Clearinghouse Limited Query Consent' },
                { text: this.$t('recruitingDocument.typeMvrRelease'), value: 'MVR Release Consent' },
                { text: this.$t('recruitingDocument.typeDrugAlcoholPolicy'), value: 'Drug and Alcohol Testing Policy' },
                { text: this.$t('recruitingDocument.typeCdl'), value: 'CDL' },
                { text: this.$t('recruitingDocument.typeMedicalCard'), value: 'Medical Card' },
                { text: this.$t('recruitingDocument.typeMvr'), value: 'MVR' },
                { text: this.$t('recruitingDocument.typePsp'), value: 'PSP' },
                { text: this.$t('recruitingDocument.typePastEmployment'), value: 'Past Employment Verification' },
                { text: this.$t('recruitingDocument.typeClearinghouse'), value: 'Clearinghouse' },
                { text: this.$t('recruitingDocument.typeOther'), value: 'Other' },
            ];
        },
        hasDocChanged() {
            return Object.keys(this.documentData).filter(field => {
                if (field !== 'updated_at') {
                    if (typeof this.documentData[field] === 'object') return JSON.stringify(this.documentData[field]) !== JSON.stringify(this.defaultDocsData[field])
                    else if (!this.documentData[field] && !this.defaultDocsData[field]) return false
                    else return this.checkValueExists(this.documentData[field]) != this.checkValueExists(this.defaultDocsData[field])
                } return false
            }).length > 0
        },
    },
    watch: {
        documentItem() {
            if (this.documentItem) {
                this.documentData.document_type = `${this.documentItem.document_type || ''}`
                    .replace(/\s*\((?:front|back)\)/gi, '')
                    .trim()
                this.documentData.date = pickerDate(this.documentItem.date)
                if (this.documentItem.document) {
                    this.fileName = this.documentItem.document.substring(this.documentItem.document.lastIndexOf('/') + 1, this.documentItem.document.indexOf('?'));
                    this.documentData.document = this.documentItem.document
                } else {
                    this.documentData.document = null;
                }
                this.defaultDocsData = JSON.parse(JSON.stringify(this.documentData))
                this.media = this.mediaData
                this.mediaID = this.mediaDataID
                this.mediaType = this.mediaDataType
            }
        }
    },
    methods: {
        ...mapActions(['setLoader', 'setNotification']),
        zoom(level) {
            if (!this.panzoom) {
                this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
                    maxScale: 5
                })
            }
            level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
        },
        resetPopup() {
            this.documentData = {
                date: new Date(),
                document: null,
                document_type: "",
            };
            this.defaultDocsData = {}
            this.showDeleteModal = false
            this.errors = {
                date: null,
                document: null,
                document_type: null,
            };
            this.fileName = null
            this.$emit("popupClose")
            this.panzoom = null
            this.$bvModal.hide("modal-document");

        },
        deleteItem(status) {
            if (status) {
                this.deleteDocItem(status, this.itemId)
                this.$bvModal.hide("modal-document");
            }
            else this.showDeleteModal = false
        },
        handleFileUpload() {
            this.documentData.document = this.$refs.docFile.files[0];
            this.fileName = this.documentData.document.name;
            this.media = URL.createObjectURL(this.documentData.document);
            if (this.$refs.docFile.files[0].type.includes('pdf')) this.mediaType = 'pdf'
            else this.mediaType = 'image'
        },
        removeFile() {
            this.fileName = null;
            this.documentData.document = null
            this.media = null
            this.mediaType = null
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        showPopup(id) {
            this.showDeleteModal = true;
            this.itemId = id;
        },
        downloadDoc(data) {
            this.setLoader(true)
            fetch(data.document)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${data.name}.${data.document.split('.').pop().split(/[#?]/)[0]}`
                    link.click();
                    link.remove()
                    this.setLoader(false)
                })
                .catch(this.setLoader(false));
        },
        async sendDocumentData() {
            try {
                const nullKeys = this.checkNullValues({
                    date: this.documentData.date,
                    document: this.documentData.document,
                    document_type: this.documentData.document_type
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    let successMsg = this.$t('recruitingDocument.docAdded')
                    let formData = new FormData();
                    let fileType = this.documentData.document instanceof File || this.documentData.document instanceof Blob;
                    if (!fileType) this.documentData.document = null
                    formData.append("date", moment(this.documentData.date).format("YYYY-MM-DD"));
                    formData.append("document_type", this.documentData.document_type);
                    if (this.documentData.document)
                        formData.append(
                            "document",
                            new File(
                                [this.documentData.document],
                                this.driver +
                                "_" + this.userCompany + "_" +
                                new Date().getTime() +
                                "." +
                                this.documentData.document["type"].split("/").pop(),
                                { type: this.documentData.document["type"] }
                            )
                        )
                    if (this.documentItem) {
                        await this.updateDoc({ id: this.id, docID: this.documentItem.id, payload: formData })
                        successMsg = this.$t('recruitingDocument.docUpdated')
                    }
                    else await this.addDoc({ id: this.id, payload: formData })
                    await this.setNotification({
                        msg: successMsg,
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$emit("documentsUpdated", true)
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('recruitingDocument.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        }
    },
}
</script>